function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 7C8.32608 7 9.59785 7.48287 10.5355 8.34237C11.4732 9.20188 12 10.3676 12 11.5832V12H2.45476C2.33415 12 2.21848 11.9561 2.1332 11.8779C2.04791 11.7997 2 11.6937 2 11.5832C2 10.3676 2.52678 9.20188 3.46447 8.34237C4.40215 7.48287 5.67392 7 7 7Z",
  fill: "#F6B704"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 7C17 7.65661 16.8815 8.30679 16.6511 8.91342C16.4208 9.52004 16.0832 10.0712 15.6576 10.5355C15.232 10.9998 14.7268 11.3681 14.1707 11.6194C13.6147 11.8707 13.0187 12 12.4168 12H12V2.45476C12 2.33415 12.0439 2.21848 12.1221 2.1332C12.2003 2.04791 12.3063 2 12.4168 2C13.0187 2 13.6147 2.12933 14.1707 2.3806C14.7268 2.63188 15.232 3.00017 15.6576 3.46447C16.0832 3.92876 16.4208 4.47996 16.6511 5.08658C16.8815 5.69321 17 6.34339 17 7Z",
  fill: "#E54335"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 17C15.6739 17 14.4021 16.5171 13.4645 15.6576C12.5268 14.7981 12 13.6324 12 12.4168V12H21.5452C21.6658 12 21.7815 12.0439 21.8668 12.1221C21.9521 12.2003 22 12.3063 22 12.4168C22 13.6324 21.4732 14.7981 20.5355 15.6576C19.5979 16.5171 18.3261 17 17 17Z",
  fill: "#4280EF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7 17C7 15.6739 7.48287 14.4021 8.34237 13.4645C9.20188 12.5268 10.3676 12 11.5832 12H12V21.5452C12 21.6658 11.9561 21.7815 11.8779 21.8668C11.7997 21.9521 11.6937 22 11.5832 22C10.3676 22 9.20188 21.4732 8.34237 20.5355C7.48287 19.5979 7 18.3261 7 17Z",
  fill: "#34A353"
});

function SvgGoogle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e3dfe282.svg";
export { ForwardRef as ReactComponent };